document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".how-list-item");
  const cardImagesMobile = document.querySelectorAll(
    ".how-right-column--mobile .how-card-image"
  );
  const cardImagesDesktop = document.querySelectorAll(
    ".how-right-column--desktop .how-card-image"
  );

  let currentActiveIndex = 0;

  // Initialize first item as active
  function initializeActive() {
    if (listItems.length > 0) {
      setActiveItem(0);
    }
  }

  // Set active item and show corresponding image
  function setActiveItem(index) {
    // Remove active class from all items
    listItems.forEach((item) => item.classList.remove("active"));
    cardImagesMobile.forEach((img) => img.classList.remove("active"));
    cardImagesDesktop.forEach((img) => img.classList.remove("active"));

    // Add active class to selected item
    if (listItems[index]) {
      listItems[index].classList.add("active");
      currentActiveIndex = index;
    }

    // Show corresponding image in both mobile and desktop versions
    if (cardImagesMobile[index]) {
      cardImagesMobile[index].classList.add("active");
    }
    if (cardImagesDesktop[index]) {
      cardImagesDesktop[index].classList.add("active");
    }
  }

  // Add click event listeners to list items
  listItems.forEach((item, index) => {
    item.addEventListener("click", () => {
      if (index !== currentActiveIndex) {
        setActiveItem(index);
      }
    });

    // Add hover effect for better UX
    item.addEventListener("mouseenter", () => {
      if (index !== currentActiveIndex) {
        item.style.opacity = "0.8";
      }
    });

    item.addEventListener("mouseleave", () => {
      item.style.opacity = "1";
    });
  });

  // Initialize on load
  initializeActive();
});
